import { BaseMapper } from '@ps/utils';
import { TemplateDetail } from '@ps/survey-utils';

import { TemplateDetailResponseDto } from '../dtos/template-detail.dto';

export class TemplateDetailMapper extends BaseMapper<
  TemplateDetailResponseDto,
  TemplateDetail
> {
  public fromDto(dto: TemplateDetailResponseDto): TemplateDetail {
    const { template } = dto;

    return {
      templateId: template.id,
      name: template.name,
      metadata: {
        surveyTitle: template.survey_title,
        surveyLocalization: template.survey_localization,
        completes: template.completes_required ?? null,
        loi: template.expected_loi,
        incidence: template.expected_ir,
        fieldTime: template.field_time,
        clickBalancing: !!template.click_balancing,
        estimatedClicks: template.estimated_clicks ?? 0,
      },
    };
  }
}
